import { UserDetailResponse } from "@/web-client/api";
import useMyself from "@/features/user/hooks/useMyself";
import { FC } from "react";
import ErrorView from "@/components/ErrorView";

interface Props {
  user: UserDetailResponse;
}

const NotFoundPostView: FC<Props> = ({ user }): JSX.Element => {
  const isMyself = useMyself(user.id);

  return (
    <ErrorView>
      {isMyself && <span>あなたの投稿は、まだありません。</span>}

      {!isMyself && (
        <span>{user.screen_name}さんは、まだ投稿をしていないようです。</span>
      )}
    </ErrorView>
  );
};

export default NotFoundPostView;
